import { render, staticRenderFns } from "./AlertConfirm.vue?vue&type=template&id=3c477f58&scoped=true&"
import script from "./AlertConfirm.vue.js?vue&type=script&lang=js&"
export * from "./AlertConfirm.vue.js?vue&type=script&lang=js&"
import style0 from "./AlertConfirm.vue?vue&type=style&index=0&id=3c477f58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c477f58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
